import React from "react";
import logo from "../images/logoOnly.png";

const MobileHero = () => {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
      <div className="mb-8 transform hover:scale-105 transition-transform duration-300">
        <img
          src={logo}
          alt="Logo Logistica Huemul"
          className="object-cover w-40 h-40 drop-shadow-lg"
        />
      </div>
      <div
        className="rounded-2xl p-8 w-full max-w-md backdrop-blur-sm"
        style={{
          backgroundColor: "hsla(220, 60%, 20%, 0.85)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
        }}
      >
        <h1 className="text-4xl font-extrabold text-white text-center tracking-tight mb-3">
          Logística Huemul
        </h1>
        <h2 className="text-2xl font-medium text-white text-center mb-6 italic">
          Siempre cerca, aunque vayas lejos
        </h2>
        <div className="h-1 w-20 bg-white mx-auto mb-6 rounded-full"></div>
        <p className="text-base text-white text-center leading-relaxed">
          Ofrecemos soluciones logísticas eficientes y confiables, conectando
          a nuestros clientes con sus destinos de manera segura y puntual.
        </p>
        <div className="mt-6 flex flex-col items-center gap-3">
          <button className="bg-white text-[#141836] px-6 py-2 rounded-full font-semibold transform hover:scale-105 transition-transform duration-300">
            Contáctanos
          </button>
          <a
            href="https://huemul.buhoonline.com/inicio.aspx"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-white text-white px-6 py-2 rounded-full font-semibold transform hover:scale-105 transition-transform duration-300 hover:bg-white/10"
          >
            Autogestión
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileHero; 